/// \file profileUseStates.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import React, {useState} from 'react';
import { profileUseStateInterface } from './profileUseStateInterface';
const ProfileUseStates = (checkTotal:(e:any)=>void, currentUserProfile:{firstName:string, lastName:string, email:string, office:string, mobile:string}|null):profileUseStateInterface => {
  let firstName = "";
  let lastName = "";
  let email = "";
  let office = "";
  let mobile = "";

  if(currentUserProfile){
    if(currentUserProfile.firstName){
      firstName = currentUserProfile.firstName;
    }
    if(currentUserProfile.lastName){
      lastName = currentUserProfile.lastName;
    }
    if(currentUserProfile.email){
      email = currentUserProfile.email;
    }
    if(currentUserProfile.office){
      office = currentUserProfile.office;
    }
    if(currentUserProfile.mobile){
      mobile = currentUserProfile.mobile;
    }
  }

  const [current, setCurrent] = useState<{
          firstName:string,
          lastName:string,
          email:string,
          office:string,
          mobile:string,
  }>({
          firstName:firstName,
          lastName:lastName,
          email:email,
          office:office,
          mobile:mobile,        
  });

const validate= (e:any) => {
  const valid = e.target.validity;
  if(valid.patternMismatch){
    e.target.value = "";
  }
  checkTotal(e);
};

  const pairs=[
        {name:"firstName",title:"* FIRST NAME",style:"input","values":{startValue:firstName}},
        {name:"lastName",title:"* LAST NAME",style:"input","values":{startValue:lastName}},
        {name:"email",title:"* EMAIL ADDRESS",style:"email","values":{onChange:validate,startValue:email}},
        {name:"office",title:"OFFICE #",style:"tel","values":{onChange:validate,startValue:office}},
        {name:"mobile",title:"MOBILE #",style:"tel","values":{onChange:validate,startValue:mobile}},
  ];

  const setCurrentProfile = setCurrent;
  const pairsProfile = pairs;
  return {     
    setCurrentProfile,
    pairsProfile,
  };
};

export default ProfileUseStates;